import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import TapTheCap from './TapTheCap';
import CustomSlide1 from './CustomSlide1';
import CustomSlide2 from './CustomSlide2';
import CustomSlide3 from './CustomSlide3';
import CustomSlide4 from './CustomSlide4';

class ProductSlider extends Component {
    getDecorIconPath(index) {
        const iconPaths = [
            '/assets/img/product-slider/prod1.png',
            '/assets/img/product-slider/prod2.png',
            '/assets/img/product-slider/prod3.png',
            '/assets/img/product-slider/prod4.png',
            '/assets/img/product-slider/prod5.png',
        ];

        return iconPaths[index % iconPaths.length];
    }

    getDecorIconPosition(index) {
        return 'ps-product-slider__decor--center';
    }

    getProducts() {
        return (Array.isArray(this.props.products) ? this.props.products : [])
            .filter((product) => product && (this.getProductImage(product) || product.name || product.product_name));
    }

    getProductImage(product) {
        return product.display_image ||
            product.product_image ||
            product.image_path ||
            product.image_url ||
            (product.media && product.media.primary_image_url) ||
            '/assets/img/logo-no-image.png';
    }

    getProductLink(product) {
        const slug = product.slug || product.product_slug;
        if (slug) {
            return `/product/${encodeURIComponent(slug)}`;
        }

        const name = product.product_name || product.name || 'Product';
        return `/product/${encodeURIComponent(String(product.id || product.product_id || name))}`;
    }

    getProductCopy(product, index) {
        const title = (product.product_name || product.name || `Product ${index + 1}`).trim();
        const subtitle = (
            product.product_subtitle ||
            product.short_description ||
            product.category_name ||
            product.brand_name ||
            product.tagline ||
            ''
        ).trim();

        return {title, subtitle};
    }

    getPrice(product) {
        const pricing = product.pricing || {};
        const offer = product.offer || pricing.offer || {};
        const hasOffer = Boolean(offer.has_offer);
        const mrp = pricing.mrp || product.mrp || '';
        return {
            sale: hasOffer
                ? (pricing.offer_price || offer.offer_price || pricing.selling_price || product.offer_price || '')
                : (pricing.selling_price || product.offer_price || ''),
            regular: mrp,
        };
    }

    shouldShowMrp(regular, sale) {
        return Number(regular || 0) > Number(sale || 0);
    }

    getOfferBadges(product, regular, sale) {
        const mrp = Number(regular);
        const price = Number(sale);
        const discount = Number.isFinite(mrp) && Number.isFinite(price) && mrp > price && price > 0
            ? Math.round(((mrp - price) / mrp) * 100) : 0;
        const badges = Array.isArray(product.badges) ? product.badges : [];
        const badge = badges.find((item) => item && (item.name || item.title || item.label));
        const label = badge ? (badge.name || badge.title || badge.label)
            : (product.badge_name || product.badge || product.product_badge || '');
        return { discount, label: product.offer?.state==='conditional' ? product.offer.offer_badge : typeof label === 'string' ? label : '' };
    }

    getRating(product) {
        const suppliedRating = [
            product.rating,
            product.rattings,
            product.average_rating,
            product.review_rating,
        ].find((rating) => rating !== undefined && rating !== null && rating !== '');
        const value = Number(suppliedRating !== undefined ? suppliedRating : 0);
        if (Number.isNaN(value)) {
            return 0;
        }
        return Math.max(0, Math.min(5, value));
    }

    getReviewCount(product) {
        const count = Number(product.review_count || product.total_reviews || product.total_review || product.reviewCount || 0);
        return Number.isNaN(count) ? 0 : count;
    }

    renderStars(rating) {
        return Array.from({length: 5}).map((_, index) => {
            const threshold = index + 1;
            const isActive = rating >= threshold;
            const isHalf = !isActive && rating > index && rating < threshold;

            return (
                <span
                    className={`ps-product-slider__star ${isActive ? 'ps-product-slider__star--active' : ''} ${isHalf ? 'ps-product-slider__star--half' : ''}`}
                    key={`star-${index}`}
                    aria-hidden="true"
                >
                    <i className={`fa ${isHalf ? 'fa-star-half-o' : (isActive ? 'fa-star' : 'fa-star-o')}`}></i>
                </span>
            );
        });
    }

    render() {
        const products = this.getProducts();
        const title = this.props.title || 'Pure Goodness for Every Home';
        const subtitle = this.props.subtitle || 'Carefully crafted. Naturally yours.';
        const reducedMotion = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const autoScroll = Boolean(this.props.autoScroll) && !reducedMotion;

        if (products.length === 0) {
            return null;
        }

        return (
            <div>
                <div className="container">
                    <section className="ps-product-slider ps-product-slider--bestsellers" aria-labelledby="product-slider-title">
                    <img className="ps-product-slider__corner ps-product-slider__corner--left" src="/assets/img/leaf-1.png" alt="" aria-hidden="true" />
                    <img className="ps-product-slider__corner ps-product-slider__corner--right" src="/assets/img/leaf-1.png" alt="" aria-hidden="true" />

                    <div className="ps-product-slider__header">
                        <div className="ps-product-slider__eyebrowRow">
                            <img className="ps-product-slider__leaf" src="/assets/img/leaf-2.png" alt="" aria-hidden="true" />
                            <span className="ps-product-slider__eyebrow">{subtitle}</span>
                            <img className="ps-product-slider__leaf ps-product-slider__leaf--right" src="/assets/img/leaf-2.png" alt="" aria-hidden="true" />
                        </div>
                        <h3 className="ps-product-slider__title ps-product-slider__titleText" id="product-slider-title">
                            <span className="ps-product-slider__titleLead">{title}</span>
                        </h3>
                        {this.props.headerDecoration || <img className="ps-product-slider__titleLine" src="/assets/img/about/about-line.png" alt="" aria-hidden="true" />}
                    </div>

                    <div className="ps-product-slider__carouselWrap">
                        <div
                            className="owl-carousel-product owl-carousel ps-product-slider__carousel"
                            data-owl-auto={autoScroll ? 'true' : 'false'}
                            data-owl-loop="false"
                            data-owl-speed={autoScroll ? '4500' : '12000'}
                            data-owl-rewind={autoScroll ? 'true' : 'false'}
                            data-owl-nav-left={this.props.compactNavigation ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m14 5-7 7 7 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="ps-carousel-control-label">Previous products</span>' : undefined}
                            data-owl-nav-right={this.props.compactNavigation ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m10 5 7 7-7 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="ps-carousel-control-label">Next products</span>' : undefined}
                            data-owl-gap="10"
                            data-owl-nav="true"
                            data-owl-dots="false"
                            data-owl-item={this.props.compactNavigation ? '4' : '2'}
                            data-owl-item-xs="2"
                            data-owl-item-sm={this.props.compactNavigation ? '2' : '3'}
                            data-owl-item-md={this.props.compactNavigation ? '3' : '4'}
                            data-owl-item-lg="4"
                            data-owl-item-xl="4"
                            data-owl-duration="1000"
                            data-owl-mousedrag="on"
                        >
                            {products.map((product, index) => {
                                const copy = this.getProductCopy(product, index);
                                const image = this.getProductImage(product);
                                const link = this.getProductLink(product);
                                const {sale, regular} = this.getPrice(product);
                                const offerBadges = this.props.showOfferBadges ? this.getOfferBadges(product, regular, sale) : {};
                                const rating = this.getRating(product);
                                const reviewCount = this.getReviewCount(product);
                                const decorIcon = this.getDecorIconPath(index);
                                const decorPosition = this.getDecorIconPosition(index);

                                return (
                                    <div className="ps-section__product" key={`${product.variation_id || product.product_id || product.id || index}-${index}`}>
                                        <article className="ps-product-slider__card">
                                            <Link className="ps-product-slider__mediaLink" to={link} aria-label={copy.title}>
                                                <div className="ps-product-slider__media">
                                                    <img className="ps-product-slider__image" src={image} alt={copy.title} loading="lazy" />
                                                    {(offerBadges.discount > 0 || offerBadges.label) && (
                                                        <div className="ps-product-slider__offer-badges">
                                                            {offerBadges.discount > 0 ? <span className="ps-product-slider__discount">{offerBadges.discount}% OFF</span> : null}
                                                            {offerBadges.label ? <span className="ps-product-slider__badge">{offerBadges.label}</span> : null}
                                                        </div>
                                                    )}
                                                </div>
                                            </Link>

                                            <div className={`ps-product-slider__decor ${decorPosition}`} aria-hidden="true">
                                                <img className="ps-product-slider__decorImage" src={decorIcon} alt="" />
                                            </div>

                                            <div className="ps-product-slider__content">
                                                <h4 className="ps-product-slider__productTitle">
                                                    <Link to={link}>{copy.title}</Link>
                                                </h4>
                                                {copy.subtitle ? (
                                                    <p className="ps-product-slider__productSubtitle">{copy.subtitle}</p>
                                                ) : null}

                                                <div className="ps-product-slider__rating" aria-label={`${rating.toFixed(1)} out of 5 stars`}>
                                                    <div className="ps-product-slider__stars">{this.renderStars(rating)}</div>
                                                    <span className="ps-product-slider__reviewCount">({reviewCount})</span>
                                                </div>

                                                {this.props.showPrice !== false && <div className="ps-product-slider__priceRow">
                                                    {sale ? <span className="ps-product-slider__price">₹{sale}</span> : null}
                                                    {this.shouldShowMrp(regular, sale) ? <span className="ps-product-slider__strike">₹{regular}</span> : null}
                                                    {offerBadges.discount > 0 ? <span className="ps-product-slider__price-offer">{offerBadges.discount}% OFF</span> : null}
                                                </div>}

                                                {this.props.showAction !== false && <Link className="ps-product-slider__button" to={link}>
                                                    Shop Now
                                                    <img src="/assets/img/right-arrow-small.png" alt="" aria-hidden="true" />
                                                </Link>}
                                            </div>
                                        </article>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    </section>
                </div>

                <TapTheCap products={products} />
                {/* <CustomSlide1 />
                 <div className="container">
                    <CustomSlide2 />
                </div>
                
                <CustomSlide4 />
                <CustomSlide3 /> */}
            </div>
        );
    }
}

export default ProductSlider;
